<template>
  <div>
    <my-carousel class="mb-4"></my-carousel>

    <swiper-example-slides-per-column class="mb-3"></swiper-example-slides-per-column>

    <home-ca class="mb-2"></home-ca>
    <home-ca-guzhu></home-ca-guzhu>
    <home-ie></home-ie>
    <home-usa></home-usa>
    <home-others></home-others>
  </div>
</template>

<script>
  import '../assets/scss/myCommon.scss'

  import MyCarousel from "../components/MyCarousel";
  import SwiperExampleSlidesPerColumn from '../components/SwiperExampleSlidesPerColumn'
  import HomeCa from "./HomeCa";
  import HomeCaGuzhu from "./HomeCaGuzhu";
  import HomeIe from "./HomeIe";
  import HomeUsa from '@/views/HomeUsa'
  import HomeOthers from '@/views/HomeOthers'

  export default {
    name: 'HomeIndex',
    components: {
      HomeOthers,
      HomeUsa,
      HomeIe,
      HomeCaGuzhu,
      HomeCa,
      MyCarousel,
      SwiperExampleSlidesPerColumn
    },
    methods: {},

    data() {
      return {

      }
    }
  }
</script>
